import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { StateType } from "../../../../utils/types";
import {
  selectTask,
  selectTasks,
  selectTasksLoaded,
  selectTasksLoading,
  selectUsers,
  selectUsersLoaded,
} from "../../../../redux/educator/selector";
import {
  deleteTask,
  getTask,
  getTaskById,
  getUser,
} from "../../../../redux/educator/actions";

const mapStateToProps = (state: StateType) => ({
  tasks: selectTasks(state),
  task: selectTask(state),
  loading: selectTasksLoading(state),
  loaded: selectTasksLoaded(state),

  users: selectUsers(state),
  usersLoaded: selectUsersLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getTask,
      getTaskById,
      getUser,
      deleteTask,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
